// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductStyles } from "@rpsc/Overrides/Components/ProductCarouselProduct";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductStyles.productGridContainer = {
    container: {
        css: css`
            max-width: 319px;
            padding: 9px;
            border: 1px solid ${color("common.border")};
            border-radius: 4px;
        `,
    },
};
productCarouselProductStyles.productBrandWrapper = {
    css: css`
        display: inline-flex;
    `,
};

productCarouselProductStyles.infoSectionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
productCarouselProductStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            position: relative;
            height: 301px;
            width: 100%;
            margin-bottom: 12px;
            ${xScreen("lte", "md")} {
                height: initial;
            }
        `,
    },
    img: {
        width: 301,
        height: 301,
        css: css`
            max-width: 100%;
            max-height: 100%;
            height: auto;
        `,
    },
};
productCarouselProductStyles.productDescriptionStyles = {
    productDetailDescription: {
        css: css`
            min-height: 38px;
            ${ellipsis(3)}
            -webkit-align-self: flex-start;
        `,
    },
    productDetailLink: {
        css: css`
            min-height: 38px;
            ${ellipsis(3)}
            -webkit-align-self: flex-start;
        `,
    },
};

productCarouselProductStyles.productPriceWrapper = {};
productCarouselProductStyles.priceAndActionsWrapper = {
    css: css`
        height: 100%;
    `,
};

productCarouselProductStyles.badgeText = {
    weight: fontConfig.weight.bold,
    size: 10,
    lineHeight: "12px",
    transform: "uppercase",
    css: css`
        width: 100%;
    `,
};

productCarouselProductStyles.productPartNumbersStyles = {
    container: {
        css: css`
            min-height: 28px;
            margin-bottom: 8px;
        `,
    },
};
productCarouselProductStyles.productAddToListLinkStyles = {};
productCarouselProductStyles.productPriceAndActionsStyles = {
    productAvailabilityStyles: {
        container: {
            gap: 0,
            css: css`
                min-height: 17px;
                display: flex;
                margin-bottom: 8px;
                ${xScreen("lte", "sm")} {
                    min-height: unset;
                }
            `,
        },
        errorWrapper: {
            css: css`
                margin-bottom: 8px;
            `,
        },
    },
    productAddToListStyles: {
        link: {
            css: css`
                margin-left: auto;
            `,
        },
    },
};
